import { Chip } from "@mui/material";
import axios from "axios"
import { useEffect } from "react";

function Genres({
  selectedGenres,
  setSelectedGenres,
  genres,
  setGenres,
  type,
  setPage
}) {

  const fetchGenres = async () => {
    const { data } = await axios.get(`https://api.themoviedb.org/3/genre/${type}/list?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`);
    setGenres(data.genres);
  }
  useEffect(() => {
    fetchGenres();
  }, [])
  const handleAdd = (genre) => {
    setSelectedGenres([...selectedGenres, genre]);
    setGenres(genres.filter((g) => g.id !== genre.id))
    setPage(1);
  }
  const handleRemove = (genre) => {
    setSelectedGenres(
      selectedGenres.filter((selected) => selected.id !== genre.id)
    );
    setGenres([...genres, genre])
    setPage(1);
  }
  return (
    <div style={{ marginBottom: '24px' }}>
      {selectedGenres && selectedGenres.map((genre) => {
        return <Chip
          style={{ margin: 2 }}
          label={genre.name}
          key={genre.id}
          clickable
          size="small"
          color="primary"
          onDelete={() => handleRemove(genre)}
        />
      })
      }
      {genres && genres.map((genre) => {
        return <Chip
          style={{ margin: 2 }}
          label={genre.name}
          key={genre.id}
          clickable
          size="small"
          onClick={() => handleAdd(genre)}
        />
      })
      }
    </div>
  )
}

export default Genres